const KEY = "THEME";

export function getTheme() {
  // 設計稿預設為淺色（state.theme = 'light'）
  return localStorage.getItem(KEY) || "light";
}

export function applyTheme(t) {
  document.documentElement.setAttribute("data-theme", t);
}

export function setTheme(t) {
  localStorage.setItem(KEY, t);
  applyTheme(t);
}

export function initTheme() {
  applyTheme(getTheme());
}

export function toggleTheme() {
  const next = getTheme() === "dark" ? "light" : "dark";
  setTheme(next);
  return next;
}
